<div class="login-v2 login-v2-auth">
  <div class="row text-center tw-mb-[10px]">
    <span>{{ 'login.v2.choose_method_to_authenticate' | translate }}</span>
  </div>
  @if (availableIdentifiers$ | async; as availableIdentifiers) {
    <div class="row auth-methods">
      @if (identifier?.identifier_type === identifiers.MSISDN) {
        <accordion [isAnimated]="true" [closeOthers]="true">
          <accordion-group #smsGroup [isOpen]="true">
            <div class="text-center" accordion-heading>{{ 'login.v2.receive_sign_in_sms' | translate }}</div>
            @if (smsGroup.isOpen) {
              <app-msisdn-otp [identifier]="identifier"/>
            }
          </accordion-group>
          @if (availableIdentifiers.includes(this.identifiers.EMAIL)) {
            <accordion-group #emailGroup>
              <div class="text-center" accordion-heading>{{ 'login.v2.receive_sign_in_email' | translate }}</div>
              @if (emailGroup.isOpen) {
                <app-email-otp [identifier]="identifier"/>
              }
            </accordion-group>
          }
        </accordion>
      }
      @if (identifier?.identifier_type === identifiers.EMAIL) {
        <accordion [isAnimated]="true" [closeOthers]="true">
          @if (availableIdentifiers.includes(this.identifiers.MSISDN)) {
            <accordion-group #smsGroup [isOpen]="true">
              <div class="text-center" accordion-heading>{{ 'login.v2.receive_sign_in_sms' | translate }}</div>
              @if (smsGroup.isOpen) {
                <app-msisdn-otp [identifier]="identifier"/>
              }
            </accordion-group>
          }
          <accordion-group #emailGroup [isOpen]="!availableIdentifiers.includes(this.identifiers.MSISDN)">
            <div class="text-center" accordion-heading>{{ 'login.v2.receive_sign_in_email' | translate }}</div>
            @if (emailGroup.isOpen) {
              <app-email-otp [identifier]="identifier"/>
            }
          </accordion-group>
        </accordion>
      }
    </div>
  }
  <div class="row">
    <button [routerLink]="['..']" class="btn btn-raised btn-block btn-default tw-mt-[20px]">
      <span>{{ 'generic.button_back' | translate }}</span>
    </button>
  </div>
</div>
